<script>
  import { isApple } from '@dabble/app';
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import interactions, { events } from './interactions';
  const metaKey = isApple ? 'Cmd' : 'Ctrl';

  const dispatch = createEventDispatcher();

  function onShortcut(event) {
    dispatch(`shortcut-${event.shortcut}`, event);
    if (~event.shortcut.indexOf(metaKey)) {
      dispatch(`shortcut-${event.shortcut.replace(metaKey, 'Meta')}`, event);
    }
    dispatch('shortcut', event);
  }

  function onEvent(event) {
    dispatch(event.type, event);
  }

  onMount(() => {
    interactions.on('shortcut', onShortcut);
    events.forEach(event => interactions.on(event, onEvent));
  });

  onDestroy(() => {
    interactions.off('shortcut', onShortcut);
    events.forEach(event => interactions.off(event, onEvent));
  });
</script>
